import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

const fetchUserFlags = async (
  apiClient: AxiosInstance,
  userUuid: string
): Promise<Record<string, boolean>> => {
  const { data } = await apiClient.get<Record<string, boolean>>(
    `/api/users/${userUuid}/flags`
  )
  return data
}

export const useGetUserFlags = (userUuid: string) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery(`user-flags-${userUuid}`, () =>
    fetchUserFlags(apiClient, userUuid)
  )
}
